import {
  GKButton,
  GKModal,
  GKSearchSelect,
  GKTextField,
  Grid2,
  PhoneInput,
  PlusIcon,
} from "components";
import useAddClient from "hooks/useAddClient";
import FamilyCreateModal from "Pages/Client/FamilyCreateModal";
import AddBranchModal from "Pages/Organisations/AddBranchModal";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useAppSelector } from "store/store";
import { GKModalProps } from "utils/commonInterface";

const ClientModal = ({ open, setOpen }: GKModalProps) => {
  const {
    isSubmitting,
    setIsBranchCreateModalOpen,
    setIsFamilyCreateModalOpen,
    // branchList,
    // familyList,
    isBranchCreateModalOpen,
    isFamilyCreateModalOpen,
    loading,
    form,
    onSubmit,
  } = useAddClient({ setOpen });

  const [hasError, setHasError] = useState(false);

  const familyList = useAppSelector((state) => state?.app?.familyList);

  // const watchClientType = form.watch("type");

  // const basketOptionList = () => {
  //   return basketList?.data?.data
  //     ?.map((dataItem: { name: string; id: number }) => {
  //       return {
  //         name: dataItem.name,
  //         value: dataItem.id,
  //       };
  //     })
  //     .filter(
  //       (data: any) =>
  //         !form
  //           .getValues("basket")
  //           ?.map((dataItem: any) => dataItem)
  //           .includes(data.value),
  //     );
  // };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Add Client"
      footer={
        <Grid2 container justifyContent={"flex-end"} gap={1}>
          <GKButton
            disabled={hasError}
            loading={isSubmitting}
            size="medium"
            type="submit"
            variant="contained"
            form="client-form"
          >
            Add Client
          </GKButton>
        </Grid2>
      }
      titleComponent={
        <Grid2
          container
          justifyContent={"flex-end"}
          alignItems={"center"}
          gap={1}
        >
          <GKButton
            size="medium"
            variant="outlined"
            onClick={() => setIsFamilyCreateModalOpen(true)}
            startIcon={<PlusIcon width={14} />}
          >
            Add Family
          </GKButton>
        </Grid2>
      }
    >
      <>
        <form onSubmit={form.handleSubmit(onSubmit)} id="client-form">
          <Grid2 container spacing={1}>
            <Grid2 size={4}>
              <Controller
                name="personalDetails.name"
                control={form.control}
                render={({ field, fieldState: { error } }) => (
                  <GKTextField
                    {...field}
                    inputLabel="Name"
                    requiredField
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={4}>
              <Controller
                name="phone"
                control={form.control}
                render={({ field, fieldState: { error } }) => (
                  <PhoneInput
                    {...field}
                    inputLabel="Phone Number"
                    requiredField
                    onSelectChange={(event: any) => {
                      form.setValue("countryCode", event);
                    }}
                    onTextChange={(event: any) => {
                      field.onChange(event);
                    }}
                    onTextValue={field.value}
                    onSelectValue={form.getValues("countryCode")}
                    error={!!error || hasError}
                    helperText={!!error && error?.message}
                    hasError={hasError}
                    setHasError={setHasError}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={4}>
              <Controller
                name="personalDetails.email"
                control={form.control}
                render={({ field, fieldState: { error } }) => (
                  <GKTextField
                    {...field}
                    inputLabel="Email"
                    placeholder="Email"
                    requiredField
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid2>
            <Grid2 size={4}>
              <Controller
                name="personalDetails.pan"
                control={form.control}
                render={({ field, fieldState: { error } }) => (
                  <GKTextField
                    {...field}
                    inputLabel="PAN"
                    placeholder="PAN"
                    requiredField
                    onChange={(event: any) =>
                      field.onChange(event.target.value.toUpperCase())
                    }
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid2>

            <Grid2 size={4}>
              <Controller
                name="family"
                control={form.control}
                render={({ field }) => (
                  <GKSearchSelect
                    disableClearable
                    inputLabel="Family"
                    options={familyList || []}
                    onChange={(e, val) => {
                      field.onChange(val?.value);
                    }}
                    getOptionLabel={(option) => option.name || option}
                    disabled={loading}
                  />
                )}
              />
            </Grid2>
          </Grid2>
        </form>
        {isBranchCreateModalOpen && (
          <AddBranchModal
            open={isBranchCreateModalOpen}
            updateData={null}
            isEditModal={false}
            setOpen={setIsBranchCreateModalOpen}
          />
        )}
        {isFamilyCreateModalOpen && (
          <FamilyCreateModal
            open={isFamilyCreateModalOpen}
            setOpen={setIsFamilyCreateModalOpen}
          />
        )}
      </>
    </GKModal>
  );
};

export default ClientModal;
